<template>
  <v-card
  flat
  class="pa-0 ga-0 d-flex justify-center align-center flex-column flex-sm-row"
  color="primary"
  rounded="lg"
  min-height="340px"
  >
    <div class="w-100 w-md-50 pa-6 d-flex flex-column justify-center align-center">
      <p class="text-center font-weight-thin" v-html="content"></p>
      <br />
      <Button
      :slim="true"
      version="action"
      :label="btn_1_content"
      @click="EmailUserMembershipInfo()"
      />
    </div>
  </v-card>
</template>

<script lang="ts" setup>
import { computed, ref } from 'vue';

import Button from '@/components/ComponentLibrary/Button.vue';
import { getWebAppUrl } from '@/services/admin_actions/apiUtils';
import { axiosLevelTech } from '@/services/axiosConfig';
import { showToast } from '@/services/notifications/toastService';
import { useModalStore } from '@/store/modalStore';

// Check for resize events to adjust the card layout
const windowWidth = ref(window.innerWidth);
window.addEventListener('resize', () => {
  windowWidth.value = window.innerWidth;
});

const btn_1_content = ref('Learn More');
const content = computed(() => {
  return "To remain in compliance with app store policies, you cannot access your membership information through the app. " +
         "You can update your membership at " + getWebAppUrl('/membership') + " or contact support for assistance.";
});

// Computed property to check if the popup has a button & open in new tab
const EmailUserMembershipInfo = () => {
  axiosLevelTech.post('/api/email/EmailLinkToMembershipPage')
    .then(() => {
      // Handle success, e.g., show a success message or redirect
      console.log('Membership information emailed successfully.');
      // show a toast or notification to inform the user
      showToast('success','Membership information has been emailed to you. Please check your inbox.', 50000);
      //close the modal
      const modalStore = useModalStore();
      modalStore.closeModal();
    })
    .catch((error) => {
      // Handle error, e.g., show an error message
      console.error('Error emailing membership information:', error);
    });
};


</script>

<style lang="scss">

</style>